export * from './baFullCalendar.component';



// WEBPACK FOOTER //
// /app/src/app/theme/components/baFullCalendar/index.ts